import React from 'react'
import ReCAPTCHA from'react-google-recaptcha/lib/recaptcha'

class Captcha extends React.Component {
  render() {
    const { input: { onChange } } = this.props

    if (!window.grecaptcha || !window.grecaptcha.render) {
      return null
    }

    return (
      <ReCAPTCHA
        onChange={onChange}
        grecaptcha={window.grecaptcha}
        ref={el => this.captcha = el}
        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
        size="invisible"
      />
    )
  }
}

export default Captcha



// WEBPACK FOOTER //
// ./src/components/Captcha/Captcha.js